/** 샵관리 — 월 고정비 (임대료·통신비·수도광열비[수도/전기/가스]·인건비·기타) */
import React from 'react';
import { hiCol } from 'components/grid/hiGrid';
import ShopGridPage from './ShopGridPage';
import {
  loadTable, persistTable, createUid, num, thisYm, today, EXP_CATEGORY_OPTIONS, EXP_UTIL_OPTIONS,
} from 'shop/shopStore';
import { selectField } from 'shop/shopPageHelpers';

const filter = (rows, v) =>
  rows.filter(
    (r) => r.mod !== 'D'
      && (!v.ym || r.ym === String(v.ym).replace(/\D/g, ''))
      && (!v.category || r.category === v.category)
  );

const cfg = {
  gridId: 'sh-expense',
  title: '월 고정비',
  uidKey: 'expenseUid',
  searchDefaults: { ym: thisYm(), category: '' },
  searchFields: () => [[
    { name: 'ym', label: '귀속월', width: '90px', labelWidth: '60px', placeholder: 'YYYYMM' },
    selectField('category', '분류', EXP_CATEGORY_OPTIONS),
  ]],
  columns: () => [
    hiCol.edTextColumn({ header: '귀속월(YYYYMM)', field: 'ym', size: 120, required: true, align: 'center' }),
    hiCol.edComboColumn({ header: '분류', field: 'category', size: 110, required: true, options: EXP_CATEGORY_OPTIONS }),
    hiCol.edComboColumn({ header: '수도광열비 구분', field: 'subCategory', size: 120, options: EXP_UTIL_OPTIONS, title: '분류가 수도광열비일 때만 사용' }),
    hiCol.edNumberColumn({ header: '금액', field: 'amount', size: 110, required: true }),
    hiCol.edDateColumn({ header: '지급일', field: 'payDate', size: 120 }),
    hiCol.edTextColumn({ header: '비고', field: 'remark', size: 260, title: '인건비는 직원명 등을 적어두세요' }),
  ],
  load: (tc) => loadTable(tc, 'expense').map((e) => ({ ...e, mod: '' })),
  filter,
  emptyRow: (rows) => ({
    expenseUid: createUid('EXP'),
    ym: rows[rows.length - 1]?.ym || thisYm(),
    category: 'RENT',
    subCategory: '',
    amount: 0,
    payDate: today(),
    remark: '',
  }),
  validate: (rows) => {
    const errors = [];
    for (const r of rows) {
      if (r.mod === 'D') continue;
      if (!/^\d{6}$/.test(String(r.ym || ''))) errors.push(`귀속월은 YYYYMM 6자리입니다: ${r.ym || '(빈값)'}`);
      if (!r.category) errors.push('분류를 선택하세요.');
      if (r.category === 'UTIL' && !r.subCategory) errors.push('수도광열비는 수도/전기/가스 구분을 선택하세요.');
    }
    return errors;
  },
  save: (tc, rows, v) => {
    persistTable(tc, 'expense', 'expenseUid', rows, (r) => filter([r], v).length > 0, (r) => ({
      ...r,
      amount: num(r.amount),
      subCategory: r.category === 'UTIL' ? r.subCategory : '',
    }));
  },
};
const ExpenseRegister = () => <ShopGridPage cfg={cfg} />;
export default ExpenseRegister;
